import request from 'utils/Httprequest';
const server = '/api/braintrain-service-photon';
export default {
  getEmployeeInfo(data) {
    const { employeeId, cipherUserId } = data;
    return request({
      url: `${server}/workbench/employee/get?employeeId=${employeeId}&cipherUserId=${cipherUserId}`,
      method: 'GET',
    });
  },
};
